/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <div class="flex-sb purper fontSize_18">
      <div class="flex1 flex-all ">
        <img class="showimg" src="../../assets/img/logo.png" />
      </div>
      <div class="height1"></div>
      <div class="flex1 ">今日销售量：{{orderNum.TodayOrderNum||0}}</div>
      <div class="height1"></div>
      <div class="flex1 ">今日客流：{{personInfo.TodayGuestNum||0}}</div>
      <!-- <div class="height1"></div>
      <div class="flex1 ">今日流量：{{personInfo.ShareNum||0}}</div> -->

    </div>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data () {
    return {
      orderNum:{},
      personInfo:{}
    }
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created () {
    this.getdata(this.formInline)
    this.AuctionOpenOrNot()
  },
  mounted(){
    let personInfo=this.$util.getStore('personInfo');
    if(personInfo){
      personInfo=JSON.parse(personInfo)
      this.GetUserInfo(personInfo)
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    GetUserInfo(personInfo) {
      this.$loading();
      this.$api
        .QueryDataFn("Web\\GetUserInfo_1_0_1&DBC=w_m", {
          UserTel:personInfo.UserTel,
        })
        .then((res) => {
          this.$loading().close();
          let data = res.data;
          if (data.OK == "True" && data.Tag && data.Tag.length > 0) {
            let { Table } = data.Tag[0];
            let p = Table[0];
            p.UserTel=personInfo.UserTel
            this.personInfo=p
            this.$util.setStore("personInfo", JSON.stringify(personInfo));
          } else {
            this.listData = [];
          }
        });
    },
    AuctionOpenOrNot(){
      this.$api.AuctionOpenOrNot().then(res=>{
        console.log(res)
      })
    },
    // 获取公司列表
    getdata (parameter) {
      let data = {};
      let personInfo = this.$util.getStore('personInfo');
      if(personInfo){
        personInfo=JSON.parse(personInfo)
      }
      if (personInfo&&personInfo.UserType == 1 || personInfo&&personInfo.UserType == 2) {
        data.CompanyGUID = personInfo.CompanyGUID;
        data.ShopGUID = '';
        data.ShopGUID = personInfo.ShopGUID;
        data.CompanyGUID = '';
      }
      this.$loading()
      // 模拟数据结束
      // return
      this.$api.GetShopOrderNum(data).then((result) => {
        this.$loading().close()
        console.log(result,700)
        if (result.data.OK != 'True') {
          this.$message.success(result.Message)
        } else if (result.data.Tag.length <= 0) {
          this.$message.success('获取订单数量失败')
        } else {
          console.log(result.data.Tag[0].Table[0])
          this.orderNum = result.data.Tag[0].Table[0];
        }
       

      })
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      // deptList(parameter)
      //   .then(res => {
      //     this.loading = false
      //     if (res.success == false) {
      //       this.$message({
      //         type: 'info',
      //         message: res.msg
      //       })
      //     } else {
      //       this.listData = res.data
      //       // 分页赋值
      //       this.pageparm.currentPage = this.formInline.page
      //       this.pageparm.pageSize = this.formInline.limit
      //       this.pageparm.total = res.count
      //     }
      //   })
      //   .catch(err => {
      //     this.loading = false
      //     this.$message.error('菜单加载失败，请稍后再试！')
      //   })
    },

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}

.purper {
  background-color: rgb(196, 122, 177);
  color: #fff;
  height: 60px;
  padding: 10px;
  text-align: center;
}

.height1 {
  height: 60px;
  width: 1px;
  background-color: #666;
}
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue